module.exports = __webpack_public_path__ + "img/yx3-zh.9dad32f2.jpg";